<div class="container-fluid page-content">
  <div class="tab-wrapper container">
    <!-- <div class="col-sm-12" style="text-align: center;">  <span>List Supplier</span> <br /></div> -->
    <mat-tab-group
      class="nav nav-tabs"
      (selectedTabChange)="onTabChange($event)"
      [selectedIndex]="selectedIndex"
      dynamicHeight
      animationDuration="0ms"
    >
      <mat-tab label="Cart Items">
        <section class="example-container mat-elevation-z8" tabindex="0">
          <div class="mb-3"></div>
          <table
            mat-table
            [dataSource]="data"
            class="example-table"
            matSort
            matSortActive="created"
            outlined="appearance"
            matSortDisableClear
            matSortDirection="desc"
          >
            <!-- Number Column -->
            <ng-container matColumnDef="SNo">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ sNo + i + 1 }}
              </td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="SKU">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU</th>
              <td mat-cell *matCellDef="let row">{{ row.item_SKU }}</td>
            </ng-container>
            <ng-container matColumnDef="ItemName">
              <th mat-header-cell *matHeaderCellDef>Item Name</th>
              <td mat-cell *matCellDef="let row">{{ row.item_Name }}</td>
            </ng-container>
            <ng-container matColumnDef="Country">
              <th mat-header-cell *matHeaderCellDef>Country Name</th>
              <td mat-cell *matCellDef="let row">
                {{ row.item_Country_Name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Action" stickyEnd>
              <th mat-header-cell *matHeaderCellDef aria-label="row actions">
                Action
              </th>
              <td mat-cell *matCellDef="let row">
                <button
                  mat-icon-button
                  color="accent"
                  (click)="openEditForm(row)"
                  matBadge="{{ badgeCounts[row.item_SKU] || 0 }}"
                  matBadgeColor="accent"
                >
                  <mat-icon
                    *ngIf="!(badgeCounts[row.item_SKU] > 0)"
                    matTooltip="Add/Edit Beneficiary"
                    matTooltipPosition="above"
                    >add</mat-icon
                  >
                  <mat-icon
                    *ngIf="badgeCounts[row.item_SKU] > 0"
                    matTooltip="Add/Edit Beneficiary"
                    matTooltipPosition="above"
                    >edit</mat-icon
                  ></button
                >|
                <button
                  mat-icon-button
                  matTooltip="Delete item from cart"
                  matTooltipPosition="above"
                  color="warn"
                  (click)="deleteRow(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator
            [length]="resultsLength"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 20, 30]"
            aria-label="View Merchant"
          ></mat-paginator>
        </section>
        <div class="d-flex justify-content-end mb-4 mt-4">
          <button
            mat-raised-button
            type="button"
            class="btn btn-secondary"
            style="margin-right: 5px"
            (click)="cancelOrder()"
          >
            Cancel order
          </button>
          <button
            mat-raised-button
            type="button"
            [disabled]="!allBadgesGreaterThanZero()"
            class="btn btn-primary"
            (click)="reviewWebFormOrder()"
          >
            Validate Order
          </button>
        </div>
      </mat-tab>
      <mat-tab label="Order Validate Items">
        <!-- <div class="mb-3 mt-4">
                   
                 <p style="color: red;">Thank you for your order! Please review the details below before finalizing your purchase.
                    if everything looks correct, please click on "Place Order" to proceed. if you need to make any changes, 
                    click "Edit Order". Thank you for choosing Global Rewards!"</p>
                
                </div> -->
        <div class="mb-3 mt-4">
          <p style="color: red">
            Thank you for your order! Please review the details below before
            finalizing your purchase.<br />If everything looks correct, please
            click on "Place Order" to proceed. If you need to make any
            modifications, go to "Cart Items". Thank you for choosing Global
            Rewards!
          </p>
        </div>
        <section class="example-container mat-elevation-z8" tabindex="0">
          <table
            mat-table
            [dataSource]="reviewOrderData"
            class="example-table"
            matSort
            matSortActive="created"
            outlined="appearance"
            matSortDisableClear
            matSortDirection="desc"
          >
            <!-- Number Column -->
            <ng-container matColumnDef="SNo">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ sNoOrderReview + i + 1 }}
              </td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="SKU">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU</th>
              <td mat-cell *matCellDef="let row">{{ row.sku }}</td>
            </ng-container>
            <ng-container matColumnDef="ItemName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Item Name
              </th>
              <td mat-cell *matCellDef="let row">{{ row.order_Item_Name }}</td>
            </ng-container>
            <!-- <ng-container matColumnDef="deliver_To_Full_Name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
                            <td mat-cell *matCellDef="let row">{{row.deliver_To_Full_Name}}</td>
                        </ng-container> -->
            <ng-container matColumnDef="deliver_To_First_Name">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let row">
                {{ row.deliver_To_First_Name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="deliver_To_Last_Name">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let row">
                {{ row.deliver_To_Last_Name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="deliver_To_Email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let row">{{ row.deliver_To_Email }}</td>
            </ng-container>
            <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef>Quantity</th>
              <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
            </ng-container>
            <ng-container matColumnDef="responseMessage">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Comments
              </th>
              <td mat-cell *matCellDef="let row">
                <span [ngClass]="getColorClass(row.responseMessage)">
                  {{ row.responseMessage }}</span
                >
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedReviewColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedReviewColumns"
            ></tr>
          </table>

          <mat-paginator
            [length]="resultsOrderReviewLength"
            [pageSize]="pageSizeOrderReview"
            [pageSizeOptions]="[10, 20, 30]"
            aria-label="View Order Review"
          ></mat-paginator>
        </section>
        <div class="row mt-4">
          <div class="col-sm-6" style="text-align: right">
            <label for="PoNumber" style="padding-top: 20px; font-weight: 400">
              PO # :</label
            >
          </div>
          <div class="col-sm-6">
            <form class="example-form">
              <mat-form-field class="example-full-width" appearance="outline">
                <!-- <mat-label class="form-label" for="poNumber">PO Number</mat-label> -->
                <input
                  matInput
                  [formControl]="poNumber"
                  #poNumber1
                  class="form-control"
                  placeholder="Please enter PO Number (if applicable)"
                />
              </mat-form-field>
            </form>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-6" style="text-align: right">
            <label
              for="invoiceEmail"
              style="padding-top: 20px; font-weight: 400"
              >Email address for invoice to be send to <span class="mandatory-star">*</span> :</label
            >
          </div>
          <div class="col-sm-6">
            <mat-form-field class="example-full-width" appearance="outline">
              <input
                matInput
                [formControl]="invoiceEmail"
                placeholder="Enter your email address"
                maxlength="60"
                required
              />
             <mat-error *ngIf="invoiceEmail.invalid"> {{ getEmailErrorMessage() }} </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="d-flex justify-content-end mb-5 mt-4">
          <button
            mat-raised-button
            type="button"
            class="btn btn-secondary"
            style="margin-right: 5px"
            (click)="cancelOrder()"
          >
            Cancel order
          </button>
          <button
            mat-raised-button
            type="button"
            [disabled]="resultsOrderReviewLength == 0 || invoiceEmail.invalid"
            class="btn btn-primary"
            (click)="openConfirmationBox()"
          >
            Place Order
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div></div>
  </div>
</div>
